import React, { useState, useEffect } from 'react';
import ThoughtsList from '../components/ThoughtsList';
import { db, auth } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

const Insights = ({ onDeleteThought }) => {
    const [insights, setInsights] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchInsights = async () => {
            const user = auth.currentUser;
            if (!user) return;

            try {
                setIsLoading(true);
                const q = query(
                    collection(db, "thoughts"),
                    where("userId", "==", user.uid),
                    where("insight", "==", true),
                    where("importance", "==", 5),
                    where("current", "==", false)
                );
                
                const querySnapshot = await getDocs(q);
                const insightsData = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setInsights(insightsData);
            } catch (error) {
                console.error("Error fetching insights:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchInsights();
    }, []);

    return (
        <div style={{ paddingTop: '80px' }}>
            <ThoughtsList
                thoughts={insights}
                title="Dailies"
                onDeleteThought={onDeleteThought}
                isLoading={isLoading}
                defaultSort="chronological"
            />
        </div>
    );
};

export default Insights; 